(() => {
  if (customElements.get('coko-edit')) return;
  customElements.define('coko-edit', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const cards = [...this.querySelectorAll('[data-edit-category]')];
      const toolbar = this.querySelector('.edit-toolbar');
      const buttons = [...this.querySelectorAll('[data-category]')];
      const count = this.querySelector('.edit-count');
      if (!cards.length || !toolbar || !count) return;
      buttons.forEach(button => {
        const category = button.dataset.category;
        if (category !== 'all' && !cards.some(card => card.dataset.editCategory === category)) button.hidden = true;
        button.addEventListener('click', () => {
          let visible = 0;
          cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.editCategory !== category; if (!card.hidden) visible++; });
          buttons.forEach(option => option.setAttribute('aria-pressed', String(option === button)));
          count.textContent = visible + (visible === 1 ? ' piece in the edit' : ' pieces in the edit');
        }, { signal: this.abort.signal });
      });
      count.textContent = cards.length + (cards.length === 1 ? ' piece in the edit' : ' pieces in the edit');
      toolbar.hidden = false;
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();
